export const persistCartStateMiddleware = (store) => (next) => (action) => {
    const result = next(action); // Let the action proceed
    const state = store.getState(); // Get the updated state
    try {
      const serializedState = JSON.stringify(state.shoppingCart); // Replace 'shoppingCart' with the correct slice name
      localStorage.setItem("shoppingCartState", serializedState); // Save to localStorage
    } catch (err) {
      console.error("Failed to save state to localStorage:", err);
    }
    return result;
  };
  